module.exports = __webpack_public_path__ + "media/audio9.bfbc8671.mp3";